function n(n,t){return"function"==typeof n?n(...t):!!n}export{n as shouldThrowError};
